<template lang="pug" src="./tariffs.pug"></template>
<style lang="scss" src="./tariffs.scss" scoped></style>

<script>
import { mapState, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import validate from '@/mixins/validate';

export default {
    mixins: [validate, validationMixin],
    data: () => ({
        requestProcessing: false,
        duplicateDialog: false,
        duplicateData: {
            brandId: null,
            newBrandId: null,
            optionId: null
        }
    }),
    validations: {
        duplicateData: {
            newBrandId: {
                required: function () {
                    return !this.duplicateDialog || !!this.duplicateData.newBrandId;
                }
            }
        }
    },
    computed: {
        ...mapGetters(['userBrandId']),
        ...mapState({
            items: state => state.finances.tariffs.items,
            brands: state => state.data.brands,
            optionClasses: state => state.data.optionClasses,
            pagination: state => state.finances.tariffs.pagination,
            filters: state => state.finances.tariffs.filters
        }),
        headers() {
            const properties = [
                'optionName', 'optionClassId', 'districtId', 'description',
                'startPrice', 'priceForKm', 'priceForWaiting', 'minPrice',
                'multiplier', 'multiplierForDriver', 'defaultOptions',
                'internal', 'hidden', 'brandId', 'actions'
            ];

            return properties.map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Options.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        brandId: {
            get() {
                return this.filters.brandId;
            },
            set(val) {
                return this.$store.commit('finances/SET_TARIFFS_BRAND_ID', val);
            }
        },
        optionName: {
            get() {
                return this.filters.optionName;
            },
            set(val) {
                return this.$store.commit('finances/SET_TARIFFS_OPTION_NAME', val);
            }
        },
        optionClassId: {
            get() {
                return this.filters.optionClassId;
            },
            set(val) {
                return this.$store.commit('finances/SET_TARIFFS_OPTION_CLASS_ID', val);
            }
        }
    },
    created() {
        if (this.userBrandId) {
            this.brandId = this.userBrandId;
        }

        this.$store.dispatch('data/getBrands').then(() => {
            if (!this.brandId) {
                this.brandId = this.brands && this.brands[0] && this.brands[0].id;
            }

            this.loadItems();
        });
        this.$store.dispatch('data/getDistricts');
        this.$store.dispatch('data/getOptionClasses');
    },
    methods: {
        loadItems(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('finances/getOptions', Object.assign({}, {
                ...this.filters,
                page
            })).then(() => {
                this.$nextTick(() => {
                    this.requestProcessing = false;
                });
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        },
        openDuplicateDialog({ id: optionId, brandId }) {
            if (this.userBrandId) {
                this.$set(this.duplicateData, 'newBrandId', this.userBrandId);
            }

            this.$set(this.duplicateData, 'optionId', optionId);
            this.$set(this.duplicateData, 'brandId', brandId);
            this.duplicateDialog = true;
        },
        closeDuplicateDialog() {
            this.$v.duplicateData.newBrandId.$reset();
            this.duplicateDialog = false;

            this.duplicateData = {
                optionId: null,
                brandId: null
            };
        },
        duplicate() {
            if (this.$v.duplicateData.newBrandId.$invalid) {
                this.$v.duplicateData.newBrandId.$touch();
                return;
            }

            this.$store.dispatch('finances/duplicateOption', this.duplicateData);
            this.closeDuplicateDialog();
        }
    }
};
</script>
